module.exports = __webpack_public_path__ + "img/ro.136c0b83.svg";